export const dnldSMSAccountData = (builder) => ({
    dnldSMSAccountData: builder.mutation({
      query: ({ user_type, search, login_user_type, created_by_userid, loggedin_user_id, user_type_id, }) => {
        return {
          url: '/download_registered_smsc_list',
          method: 'GET',
          params: { user_type, search, login_user_type, created_by_userid, loggedin_user_id, user_type_id, },
          headers: {
            'Content-Type': 'text/csv',
          },
          responseHandler: (response)=>response.blob(),
        };
      },
    }),
  });
  